import TripListItem from './TripListItem';

export default TripListItem;
